import React from "react";
import { Row, Col } from "reactstrap";

const Headings = ({ headingFocused }) => {
  return (
    <>
      <Row className="mb-2 m-auto set-scrollbox-width responsive-fontsize">
        <Col
          xs={6}
          className={`
            offset-18 d-flex align-items-end justify-content-start small fw-bold border-bottom
            ${
              headingFocused === "hours1" ||
              headingFocused === "hours2" ||
              headingFocused === "hours3"
                ? "heading-focused"
                : "heading"
            }
          `}
          style={{whiteSpace:'nowrap'}}
        >
          Bedömt antal Åtgärdstimmar
        </Col>
        <Col
          xs={4}
          className={`
            offset-3 d-flex align-items-end justify-content-start small fw-bold border-bottom
            ${
              headingFocused === "costs1" ||
              headingFocused === "costs2" ||
              headingFocused === "costs3"
                ? "heading-focused"
                : "heading"
            }
          `}
          style={{whiteSpace:'nowrap'}}
        >
          Bedömd Kostnad
        </Col>
      </Row>

      <Row className="mb-3 m-auto border-bottom set-scrollbox-width">
        <Col
          xs={5}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "measureName" ? "heading-focused" : "heading"}
          `}
        >
          Åtgärd
        </Col>

        <Col
          xs={2}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "priority" ? "heading-focused" : "heading"}
          `}
        >
          Prioritet
        </Col>

        <Col
          xs={4}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "startdate" ? "heading-focused" : "heading"}
          `}
        >
          Startdatum
        </Col>

        <Col
          xs={4}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "enddate" ? "heading-focused" : "heading"}
          `}
        >
          Klartdatum
        </Col>

        <Col
          xs={2}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "responsible" ? "heading-focused" : "heading"}
          `}
        >
          Ansvarig
        </Col>

        <Col
          xs={2}
          className={`
            offset-1 d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "hours1" ? "heading-focused" : "heading"}
          `}
        >
          År 1
        </Col>

        <Col
          xs={2}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "hours2" ? "heading-focused" : "heading"}
          `}
        >
          År 2
        </Col>

        <Col
          xs={2}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "hours3" ? "heading-focused" : "heading"}
          `}
        >
          År 3
        </Col>

        <Col
          xs={3}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "hours-total" ? "heading-focused" : "heading"}
          `}
        >
          Total
        </Col>

        <Col
          xs={3}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "costs1" ? "heading-focused" : "heading"}
          `}
        >
          År 1
        </Col>

        <Col
          xs={3}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "costs2" ? "heading-focused" : "heading"}
          `}
        >
          År 2
        </Col>

        <Col
          xs={3}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "costs3" ? "heading-focused" : "heading"}
          `}
        >
          År 3
        </Col>

        <Col
          xs={3}
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "costs-total" ? "heading-focused" : "heading"}
          `}
        >
          Total
        </Col>
      </Row>
    </>
  );
};

export default Headings;
